export enum UserStates {
    Online = 'online',
    Offline = 'offline'
}
